import React, { useState, useEffect } from "react";
import {
  Typography,
  Container,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { API_URL } from "../helpers/api_helper";

import { useAppContext } from "../context/AppContext";
import Toast from "./toast";
import { UpdateProfilePicture } from "../helpers/User";
import userService from "../helpers/user.service";
import Person from "../assets/Person.svg";

const UpdateProfile = ({ HandleClose }) => {
  const User = localStorage.getItem("User");
  const { isMobile, isSmallMobile } = useAppContext();

  const [isLoading, setisLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const user_ = JSON.parse(User);
    if (
      user_?.UserInfo?.User_Photo_Path !== null &&
      user_?.UserInfo?.User_Photo_Path !== ""
    ) {
      setPreview(API_URL + user_?.UserInfo?.User_Photo_Path);
    } else {
      setPreview(Person);
    }
  }, []);

  //-------Upload File-------------
  const convertBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result.replace("data:", "").replace(/^.+,/, ""));
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      Toast.error("error");
    };
  };

  const handleUploadFiles = async (files, previewUrl) => {
    console.log(files);
    if (files.length > 0) {
      files.map(async (file) => {
        const fileSize = files.size;
        if (fileSize > 2097152) {
          alert(`Maximum file size is 2 Mb.`);
        } else if (file.type === "image/png" || file.type === "image/jpeg") {
          await convertBase64(file, (result) => {
            const newItem = {
              Name: file.name,
              fileType: file.type,
              File: result,
              previewUrl: previewUrl,
            };
            setSelectedFile(newItem);
            setPreview(previewUrl);
          });
        } else {
          Toast.error("Only Images are allowed.");
        }
      });
    } else {
      Toast.error("Only Images are allowed.");
    }
  };

  const handleFileChange = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    setSelectedFile(null);
    const file = e.target.files[0];
    const reader = new FileReader();
    let previewUrl;
    reader.onload = () => {
      previewUrl = reader.result;
      handleUploadFiles(chosenFiles, previewUrl);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  // -----------------------------

  const handleSave = async () => {
    setisLoading(true);
    const user_ = JSON.parse(User);
    if (selectedFile !== null) {
      let body = {
        images: selectedFile,
        User: user_?.UserInfo?.id,
      };
      const response = await UpdateProfilePicture(body);
      if (response.isSuccess === true && response.statusCode === 200) {
        const url = response?.data?.profilePictureURL;
        console.log(url);
        userService.Update_Users_Profile(url);
        setPreview(url);
        Toast.success(response.message);
        HandleClose();
      } else {
        console.log(response.message);
        Toast.error(response.message);
      }
      setisLoading(false);
    } else {
      setisLoading(false);
      Toast.error("Select an image first.");
    }
  };

  return (
    <Container
      style={{
        backgroundColor: "#303030",
        width: isMobile ? "90%" : "40%",
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          p: 2,
          borderBottom: "1px solid #444",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          textAlign: "center",
          padding: "8px 0px",
        }}
      >
        <Typography fontSize={"32px"} color="#ffffff" width={"100%"}>
          Change Profile Picture
        </Typography>
        <IconButton
          onClick={() => HandleClose()}
          sx={{ color: "#999", ml: "auto" }}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div
        style={{
          marginTop: "30px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={preview}
          alt="profile image"
          style={{
            width: 100,
            height: 100,
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
        <Button
          variant="contained"
          component="label"
          sx={{
            mt: 2,
            backgroundColor: "#494949", // darker pink on hover
            "&:hover": {
              backgroundColor: "#505050", // darker pink on hover
            },
          }}
        >
          Browse
          <input
            hidden
            accept="image/png, image/jpeg"
            type="file"
            onChange={(e) => handleFileChange(e)}
          />
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            handleSave("login");
          }}
          sx={{
            backgroundColor: "#6366f1",
            borderRadius: "8px",
            padding: "3px",
            width: "80px",
            fontSize: "1rem",
            fontWeight: 600,
            textTransform: "none",
            my: 3,
            "&:hover": { backgroundColor: "#5855eb" },
          }}
        >
          {isLoading === true ? (
            <CircularProgress color="#5855eb" size={"24px"} />
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </Container>
  );
};

export default UpdateProfile;
